/**
 * Точка входа Vite: корень React + глобальные стили игры.
 *
 * StrictMode намеренно отключен: симуляция вешает DOM-слушатели и
 * запускает rAF один раз; двойной mount оставил бы «осиротевший» цикл.
 */

import { createRoot } from "react-dom/client";
import App from "./App";
import "./styles/game.css";
import "./styles/shell.css";

const el = document.getElementById("root");
if (!el) {
  throw new Error("#root missing — check index.html");
}

createRoot(el).render(<App />);
